module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab150-76fa4959341f931edae130df5c64ddf5.jpg";